import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Inventory from './pages/Inventory';
import Production from './pages/Production';
import Tailors from './pages/Tailors';
import Cutters from './pages/Cutters';
import MyWork from './pages/MyWork';
import MyCutting from './pages/MyCutting';
import Sales from './pages/Sales';
import Purchases from './pages/Purchases';
import Expenses from './pages/Expenses';
import Reports from './pages/Reports';
import UsersPage from './pages/Users';
import SettingsPage from './pages/Settings';
import Salary from './pages/Salary';
import { ROLE_NAV, homeRoute } from './lib/utils';

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-[#F8FAFC]">
        <div className="animate-pulse text-slate-400 font-heading">Loading Khayyat Al-Babji ERP…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function RoleRoute({ page, element }) {
  const { user } = useAuth();
  const nav = ROLE_NAV[user?.role];
  const permitted = nav === 'all' || (Array.isArray(nav) && nav.includes(page)) ||
    (page === 'my-work' && user?.role === 'tailor') || (page === 'my-cutting' && user?.role === 'cutter');
  if (!permitted) return <Navigate to={homeRoute(user?.role)} replace />;
  return element;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <Login />} />
      <Route path="/dashboard" element={<Protected><RoleRoute page="dashboard" element={<Dashboard />} /></Protected>} />
      <Route path="/inventory" element={<Protected><RoleRoute page="inventory" element={<Inventory />} /></Protected>} />
      <Route path="/production" element={<Protected><RoleRoute page="production" element={<Production />} /></Protected>} />
      <Route path="/tailors" element={<Protected><RoleRoute page="tailors" element={<Tailors />} /></Protected>} />
      <Route path="/cutters" element={<Protected><RoleRoute page="cutters" element={<Cutters />} /></Protected>} />
      <Route path="/my-work" element={<Protected><RoleRoute page="my-work" element={<MyWork />} /></Protected>} />
      <Route path="/my-cutting" element={<Protected><RoleRoute page="my-cutting" element={<MyCutting />} /></Protected>} />
      <Route path="/sales" element={<Protected><RoleRoute page="sales" element={<Sales />} /></Protected>} />
      <Route path="/purchases" element={<Protected><RoleRoute page="purchases" element={<Purchases />} /></Protected>} />
      <Route path="/expenses" element={<Protected><RoleRoute page="expenses" element={<Expenses />} /></Protected>} />
      <Route path="/reports" element={<Protected><RoleRoute page="reports" element={<Reports />} /></Protected>} />
      <Route path="/users" element={<Protected><RoleRoute page="users" element={<UsersPage />} /></Protected>} />
      <Route path="/settings" element={<Protected><RoleRoute page="settings" element={<SettingsPage />} /></Protected>} />
      <Route path="/salary" element={<Protected><RoleRoute page="salary" element={<Salary />} /></Protected>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
